import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=46d35457&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ResetPassword.vue?vue&type=style&index=1&id=46d35457&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d35457",
  null
  
)

export default component.exports